<style lang="scss">
  @import "@/assets/scss/vuexy/pages/Detail.scss";
</style>
<template>
    <div>
        <div class="item-grid-view vx-row match-height mt-4">
            <div class="lg:w-1/3 sm:w-1/2 w-full">
                <div class="w-full grid-view-item">
                    <vx-card class="grid-view-item mb-base overflow-hidden">
                        <gridPrincipalItem
                          img="agro"
                          :name="response.description"
                          description="Alias"
                          :name2="response.serie"
                          :description2="$t('Labels.Serie')"
                        ></gridPrincipalItem>
                        <div class="absolute right-0 top-0">
                            <vs-button  @click="deviceStatistics(response.agro_id)" class="watersonic edit-button mr-2 mt-2" color="primary" icon="bar_chart" type="border">
                            </vs-button>
                            <vs-button v-if="$store.state.AppActiveUser.userRole === 'MA'"  @click="goToConfig(response.agro_id)" class="watersonic edit-button mr-2 mt-2" color="grey" icon="icon-settings" icon-pack="feather" type="border">
                            </vs-button>
                        </div>
                        <vs-divider/>
                        <valueItem :description="$t('Labels.EnvironmentTemperature')" img="pressure" :value="parseFloat(response.environment_temperature || 0).toFixed(2)" unit="°C" :min="response.min_environment_temperature" :max="response.max_environment_temperature"></valueItem>
                        <valueItem :description="$t('Labels.EnvironmentHumidity')" img="pressure" :value="parseFloat(response.environment_humidity || 0).toFixed(2)" unit="%" :min="response.min_environment_humidity" :max="response.max_environment_humidity"></valueItem>
                        <valueItem :description="$t('Labels.EnvironmentIllumination')" img="pressure" :value="parseFloat(response.environment_illumination || 0).toFixed(2)" unit="%" :min="response.min_environment_illumination" :max="response.max_environment_illumination"></valueItem>
                        <valueItem :description="$t('Labels.EnvironmentO2')" img="pressure" :value="parseFloat(response.environment_o2 || 0).toFixed(2)" unit="%" :min="response.min_environment_o2" :max="response.max_environment_o2"></valueItem>
                        <valueItem :description="$t('Labels.SoilTemperature')" img="globe" :value="parseFloat(response.soil_temperature || 0).toFixed(2)" unit="°C" :min="response.min_soil_temperature" :max="response.max_soil_temperature"></valueItem>
                        <valueItem :description="$t('Labels.SoilHumidity')" img="globe" :value="parseFloat(response.soil_humidity || 0).toFixed(2)" unit="%" :min="response.min_soil_humidity" :max="response.max_soil_humidity"></valueItem>
                        <valueItem :description="$t('Labels.SoilElectricConductivity')" img="globe" :value="parseFloat(response.soil_electric_conductivity || 0).toFixed(2)" unit="us/cm" :min="response.min_soil_electric_conductivity" :max="response.max_soil_electric_conductivity"></valueItem>
                        <valueItem :description="$t('Labels.SoilN')" img="globe" :value="parseFloat(response.soil_n || 0).toFixed(2)" unit="mg/L" :min="response.min_soil_n" :max="response.max_soil_n"></valueItem>
                        <valueItem :description="$t('Labels.SoilP')" img="globe" :value="parseFloat(response.soil_p || 0).toFixed(2)" unit="mg/L" :min="response.min_soil_p" :max="response.max_soil_p"></valueItem>
                        <valueItem :description="$t('Labels.SoilK')" img="globe" :value="parseFloat(response.soil_k || 0).toFixed(2)" unit="mg/L" :min="response.min_soil_k" :max="response.max_soil_k"></valueItem>
                        <valueItem :description="$t('Labels.SoilPH')" img="globe" :value="parseFloat(response.soil_ph || 0).toFixed(2)" unit="PH" :min="response.min_soil_ph" :max="response.max_soil_ph"></valueItem>
                        <valueItem :description="$t('Labels.Battery')" img="battery" :value="parseFloat(response.battery_status || 0).toFixed(2)" unit="%" :min="response.min_battery_status" :max="response.max_battery_status"></valueItem>
                        <valueItem :description="$t('Labels.Date')" img="fecha" :value="response.updated_at"></valueItem>
                    </vx-card>
                </div>

            </div>
            <div class="vx-col lg:w-2/3 sm:w-2/3 w-full">
                <vx-card class="grid-view-item mb-base overflow-hidden address-card">
                    <div class="avatar-info-container">
                        <span class="account-number">
                           {{$t("Labels.DeviceLocation")}}
                        </span>
                        <feather-icon
                          icon="EditIcon"
                          @click="editMap = true"
                          class="float-right cursor-pointer"
                          svgClasses="hover:text-primary"
                          v-if="!editMap"/>
                        <feather-icon
                          icon="SaveIcon"
                          @click="saveMap()"
                          class="float-right cursor-pointer"
                          svgClasses="hover:text-primary"
                          v-if="editMap && $store.state.AppActiveUser.userRole === 'MA'"/>
                        <div class="map-container basic-example" v-if="status_mapa">
                            <l-map :center="center" :zoom="zoom" v-if="response">
                                <l-tile-layer :attribution="attribution" :url="url">
                                </l-tile-layer>
                                <l-marker :draggable="editMap" :lat-lng="marker" ref="position_marker">
                                    <l-icon :icon-anchor="staticAnchor">
                                        <img :src="require(`@/assets/images/markers/0.svg`)" width="25px;" alt="ícono marcador"/>
                                    </l-icon>
                                </l-marker>
                            </l-map>
                        </div>
                        <div class="mt-2">
                          <label>{{$t('Labels.References')}}:</label>{{response.location_string  }}
                        </div>
                    </div>
                </vx-card>
            </div>
        </div>
        <div class="item-grid-view vx-row match-height mt-4">
            <div class="w-full">
                <vx-card class="grid-view-item mb-base overflow-hidden">
                    <div class="text-center text-3xl">{{$t("Labels.Alerts")}}</div>
                    <vs-divider/>
                    <div class="container-alerts" v-if="showAlerts">
                        <minMaxItem
                          :title="$t('Labels.EnvironmentTemperature')"
                          :min="response.min_environment_temperature"
                          :max="response.max_environment_temperature"
                          unit="°C"
                          img="pressure_gray"
                          :url="`modelo/agro/${response.agro_id}`"
                          paramMin="min_environment_temperature"
                          paramMax="max_environment_temperature"
                          type="PUT"
                          :limitMin="limits.environment_temperature.min || 0"
                          :limitMax="limits.environment_temperature.max || 0"
                        />
                        <minMaxItem
                          :title="$t('Labels.EnvironmentHumidity')"
                          :min="response.min_environment_humidity"
                          :max="response.max_environment_humidity"
                          unit="%"
                          img="pressure_gray"
                          :url="`modelo/agro/${response.agro_id}`"
                          paramMin="min_environment_humidity"
                          paramMax="max_environment_humidity"
                          type="PUT"
                          :limitMin="limits.environment_humidity.min || 0"
                          :limitMax="limits.environment_humidity.max || 0"
                        />
                        <minMaxItem
                          :title="$t('Labels.EnvironmentIllumination')"
                          :min="response.min_environment_illumination"
                          :max="response.max_environment_illumination"
                          unit="%"
                          img="pressure_gray"
                          :url="`modelo/agro/${response.agro_id}`"
                          paramMin="min_environment_illumination"
                          paramMax="max_environment_illumination"
                          type="PUT"
                          :limitMin="limits.environment_illumination.min || 0"
                          :limitMax="limits.environment_illumination.max || 0"
                        />
                        <minMaxItem
                          :title="$t('Labels.EnvironmentO2')"
                          :min="response.min_environment_o2"
                          :max="response.max_environment_o2"
                          unit="%"
                          img="pressure_gray"
                          :url="`modelo/agro/${response.agro_id}`"
                          paramMin="min_environment_o2"
                          paramMax="max_environment_o2"
                          type="PUT"
                          :limitMin="limits.environment_o2.min || 0"
                          :limitMax="limits.environment_o2.max || 0"
                        />
                        <minMaxItem
                          :title="$t('Labels.SoilTemperature')"
                          :min="response.min_soil_temperature"
                          :max="response.max_soil_temperature"
                          unit="°C"
                          img="globe_gray"
                          :url="`modelo/agro/${response.agro_id}`"
                          paramMin="min_soil_temperature"
                          paramMax="max_soil_temperature"
                          type="PUT"
                          :limitMin="limits.soil_temperature.min || 0"
                          :limitMax="limits.soil_temperature.max || 0"
                        />
                        <minMaxItem
                          :title="$t('Labels.SoilHumidity')"
                          :min="response.min_soil_humidity"
                          :max="response.max_soil_humidity"
                          unit="%"
                          img="globe_gray"
                          :url="`modelo/agro/${response.agro_id}`"
                          paramMin="min_soil_humidity"
                          paramMax="max_soil_humidity"
                          type="PUT"
                          :limitMin="limits.soil_humidity.min || 0"
                          :limitMax="limits.soil_humidity.max || 0"
                        />
                        <minMaxItem
                          :title="$t('Labels.SoilElectricConductivity')"
                          :min="response.min_soil_electric_conductivity"
                          :max="response.max_soil_electric_conductivity"
                          unit="us/cm"
                          img="globe_gray"
                          :url="`modelo/agro/${response.agro_id}`"
                          paramMin="min_soil_electric_conductivity"
                          paramMax="max_soil_electric_conductivity"
                          type="PUT"
                          :limitMin="limits.soil_electric_conductivity.min || 0"
                          :limitMax="limits.soil_electric_conductivity.max || 0"
                        />
                        <minMaxItem
                          :title="$t('Labels.SoilN')"
                          :min="response.min_soil_n"
                          :max="response.max_soil_n"
                          unit="mg/L"
                          img="globe_gray"
                          :url="`modelo/agro/${response.agro_id}`"
                          paramMin="min_soil_n"
                          paramMax="max_soil_n"
                          type="PUT"
                          :limitMin="limits.soil_n.min || 0"
                          :limitMax="limits.soil_n.max || 0"
                        />
                        <minMaxItem
                          :title="$t('Labels.SoilP')"
                          :min="response.min_soil_p"
                          :max="response.max_soil_p"
                          unit="mg/L"
                          img="globe_gray"
                          :url="`modelo/agro/${response.agro_id}`"
                          paramMin="min_soil_p"
                          paramMax="max_soil_p"
                          type="PUT"
                          :limitMin="limits.soil_p.min || 0"
                          :limitMax="limits.soil_p.max || 0"
                        />
                        <minMaxItem
                          :title="$t('Labels.SoilK')"
                          :min="response.min_soil_k"
                          :max="response.max_soil_k"
                          unit="mg/L"
                          img="globe_gray"
                          :url="`modelo/agro/${response.agro_id}`"
                          paramMin="min_soil_k"
                          paramMax="max_soil_k"
                          type="PUT"
                          :limitMin="limits.soil_k.min || 0"
                          :limitMax="limits.soil_k.max || 0"
                        />
                        <minMaxItem
                          :title="$t('Labels.SoilPH')"
                          :min="response.min_soil_phl"
                          :max="response.max_soil_ph"
                          unit="PH"
                          img="globe_gray"
                          :url="`modelo/agro/${response.agro_id}`"
                          paramMin="min_soil_ph"
                          paramMax="max_soil_ph"
                          type="PUT"
                          :limitMin="limits.soil_ph.min || 0"
                          :limitMax="limits.soil_ph.max || 0"
                        />
                        <minMaxItem
                          :title="$t('Labels.Battery')"
                          :min="response.min_battery_status"
                          :max="response.max_battery_status"
                          unit="%"
                          img="battery_gray"
                          :url="`modelo/agro/${response.agro_id}`"
                          paramMin="min_battery_status"
                          paramMax="max_battery_status"
                          type="PUT"
                          :limitMin="limits.battery_status.min || 0"
                          :limitMax="limits.battery_status.max || 0"
                        />
                    </div>
                </vx-card>
            </div>
        </div>
    </div>
</template>
<script>
import {
  LMap,
  LTileLayer,
  LMarker,
  LIcon
} from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'
import gridPrincipalItem from '@/components/gridPrincipalItem/gridPrincipalItem.vue'
import valueItem from '@/components/valueItem/valueItem.vue'
import minMaxItem from '@/components/minMaxItem/minMaxItem.vue'
import { request } from '@/request.js'
/* global L:true */

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    minMaxItem,
    valueItem,
    gridPrincipalItem
  },

  data () {
    return {
      zoom: 17,
      center: L.latLng(47.41322, -1.219482),
      url: 'https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png',
      attribution: '',
      marker: L.latLng(47.41322, -1.219482),
      imagePath: 'images/vendor/leaflet/dist/',
      staticAnchor: [12, 27],
      response: [],
      icon_marker: [],
      status_mapa: false,
      uuid: this.$route.params.uuid,
      showAlerts: false,
      editMap: false,
      limits: {}
    }
  },

  methods: {
    async getResponse () {
      const params = {
        url: `modelo/agro/${this.uuid}`,
        method: 'GET'
      }
      await request(params).then(response => {
        this.response = response.data.data
        this.showAlerts = true
        this.limits = response.data.limits
        const [lat, long] = this.response.latlong.split(',')
        this.marker = L.latLng(lat, long)
        this.center = L.latLng(lat, long)
        this.status_mapa = true
      })
    },
    async saveMap () {
      const location = this.$refs.position_marker.mapObject.getLatLng()
      const params = {
        url: `modelo/agro/${this.uuid}`,
        method: 'PUT',
        params: {
          latlong: `${location.lat},${location.lng}`
        }
      }
      await request(params).then(() => {
        this.editMap = false
      })
    },
    goToConfig () {
      window.location.href = `/agro/config/${this.uuid}`
    },

    deviceStatistics () {
      window.location.href = `/agro/statistics/${this.uuid}`
    }

  },
  sockets: {
    agro (payload) {
      if (this.uuid === payload.uuid) {
        this.response.ahum = payload.ahum
        this.response.atemp = payload.atemp
        this.response.ground_hum = payload.ground_hum
        this.response.rain_level = payload.rain_level
        this.response.status = payload.status
        this.response.updated_at = payload.updated_at
      }
    }
  },
  created () {
    this.getResponse()
  }
}
</script>
<style scoped="">
  .vue2leaflet-map >>> .leaflet-shadow-pane {
    display: none !important;
  }
>>>.vs-input--label {
    padding: 0;
  }
</style>
